// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-comment-manage {

    width: 100%;
}

.app-comment-manage h2 {

    color: white;

    font-size: 32px;

    margin-bottom: 24px;
}

/* 등록 */

.comment-form {

    display: flex;

    flex-direction: column;

    gap: 12px;

    margin-bottom: 30px;
}

.comment-form input,
.comment-form textarea {

    width: 100%;

    padding: 14px;

    border-radius: 12px;

    border:
            1px solid rgba(
                    255,
                    255,
                    255,
                    0.1
            );

    background:
            rgba(
                    255,
                    255,
                    255,
                    0.05
            );

    color: white;

    box-sizing: border-box;
}

.comment-form textarea {

    min-height: 120px;

    resize: vertical;
}

.comment-form button {

    height: 48px;

    border: none;

    border-radius: 12px;

    background:
            linear-gradient(
                    135deg,
                    #6f3cff,
                    #2d9cff
            );

    color: white;

    font-weight: 700;

    cursor: pointer;
}

/* 댓글 목록 */

.app-comment-list {

    display: flex;

    flex-direction: column;

    gap: 18px;
}

.app-comment-card {

    display: flex;

    justify-content: space-between;

    align-items: center;

    gap: 20px;

    padding: 20px;

    border-radius: 20px;

    background:
            rgba(
                    255,
                    255,
                    255,
                    0.04
            );

    border:
            1px solid rgba(
                    255,
                    255,
                    255,
                    0.08
            );
}

.app-comment-info {

    flex: 1 1;
}

.comment-meta {

    display: flex;

    gap: 10px;

    margin-bottom: 10px;
}

.comment-meta span {

    padding: 4px 10px;

    border-radius: 999px;

    background:
            rgba(
                    111,
                    60,
                    255,
                    0.15
            );

    color:
            rgba(
                    255,
                    255,
                    255,
                    0.8
            );

    font-size: 12px;
}

.app-comment-info h4 {

    margin: 0 0 10px;

    color: white;
}

.app-comment-info p {

    margin: 0;

    color:
            rgba(
                    255,
                    255,
                    255,
                    0.8
            );

    white-space: pre-wrap;

    line-height: 1.6;
}

.delete-btn {

    height: 40px;

    padding: 0 18px;

    border: none;

    border-radius: 10px;

    background: #ff4d67;

    color: white;

    font-weight: 600;

    cursor: pointer;
}

@media (max-width: 768px) {

    .app-comment-card {

        flex-direction: column;

        align-items: flex-start;
    }

    .delete-btn {

        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/AppCommentManage.css"],"names":[],"mappings":"AAAA;;IAEI,WAAW;AACf;;AAEA;;IAEI,YAAY;;IAEZ,eAAe;;IAEf,mBAAmB;AACvB;;AAEA,OAAO;;AAEP;;IAEI,aAAa;;IAEb,sBAAsB;;IAEtB,SAAS;;IAET,mBAAmB;AACvB;;AAEA;;;IAGI,WAAW;;IAEX,aAAa;;IAEb,mBAAmB;;IAEnB;;;;;;aAMS;;IAET;;;;;;aAMS;;IAET,YAAY;;IAEZ,sBAAsB;AAC1B;;AAEA;;IAEI,iBAAiB;;IAEjB,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;;IAEZ,YAAY;;IAEZ,mBAAmB;;IAEnB;;;;;aAKS;;IAET,YAAY;;IAEZ,gBAAgB;;IAEhB,eAAe;AACnB;;AAEA,UAAU;;AAEV;;IAEI,aAAa;;IAEb,sBAAsB;;IAEtB,SAAS;AACb;;AAEA;;IAEI,aAAa;;IAEb,8BAA8B;;IAE9B,mBAAmB;;IAEnB,SAAS;;IAET,aAAa;;IAEb,mBAAmB;;IAEnB;;;;;;aAMS;;IAET;;;;;;aAMS;AACb;;AAEA;;IAEI,SAAO;AACX;;AAEA;;IAEI,aAAa;;IAEb,SAAS;;IAET,mBAAmB;AACvB;;AAEA;;IAEI,iBAAiB;;IAEjB,oBAAoB;;IAEpB;;;;;;aAMS;;IAET;;;;;;aAMS;;IAET,eAAe;AACnB;;AAEA;;IAEI,gBAAgB;;IAEhB,YAAY;AAChB;;AAEA;;IAEI,SAAS;;IAET;;;;;;aAMS;;IAET,qBAAqB;;IAErB,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;;IAEZ,eAAe;;IAEf,YAAY;;IAEZ,mBAAmB;;IAEnB,mBAAmB;;IAEnB,YAAY;;IAEZ,gBAAgB;;IAEhB,eAAe;AACnB;;AAEA;;IAEI;;QAEI,sBAAsB;;QAEtB,uBAAuB;IAC3B;;IAEA;;QAEI,WAAW;IACf;AACJ","sourcesContent":[".app-comment-manage {\n\n    width: 100%;\n}\n\n.app-comment-manage h2 {\n\n    color: white;\n\n    font-size: 32px;\n\n    margin-bottom: 24px;\n}\n\n/* 등록 */\n\n.comment-form {\n\n    display: flex;\n\n    flex-direction: column;\n\n    gap: 12px;\n\n    margin-bottom: 30px;\n}\n\n.comment-form input,\n.comment-form textarea {\n\n    width: 100%;\n\n    padding: 14px;\n\n    border-radius: 12px;\n\n    border:\n            1px solid rgba(\n                    255,\n                    255,\n                    255,\n                    0.1\n            );\n\n    background:\n            rgba(\n                    255,\n                    255,\n                    255,\n                    0.05\n            );\n\n    color: white;\n\n    box-sizing: border-box;\n}\n\n.comment-form textarea {\n\n    min-height: 120px;\n\n    resize: vertical;\n}\n\n.comment-form button {\n\n    height: 48px;\n\n    border: none;\n\n    border-radius: 12px;\n\n    background:\n            linear-gradient(\n                    135deg,\n                    #6f3cff,\n                    #2d9cff\n            );\n\n    color: white;\n\n    font-weight: 700;\n\n    cursor: pointer;\n}\n\n/* 댓글 목록 */\n\n.app-comment-list {\n\n    display: flex;\n\n    flex-direction: column;\n\n    gap: 18px;\n}\n\n.app-comment-card {\n\n    display: flex;\n\n    justify-content: space-between;\n\n    align-items: center;\n\n    gap: 20px;\n\n    padding: 20px;\n\n    border-radius: 20px;\n\n    background:\n            rgba(\n                    255,\n                    255,\n                    255,\n                    0.04\n            );\n\n    border:\n            1px solid rgba(\n                    255,\n                    255,\n                    255,\n                    0.08\n            );\n}\n\n.app-comment-info {\n\n    flex: 1;\n}\n\n.comment-meta {\n\n    display: flex;\n\n    gap: 10px;\n\n    margin-bottom: 10px;\n}\n\n.comment-meta span {\n\n    padding: 4px 10px;\n\n    border-radius: 999px;\n\n    background:\n            rgba(\n                    111,\n                    60,\n                    255,\n                    0.15\n            );\n\n    color:\n            rgba(\n                    255,\n                    255,\n                    255,\n                    0.8\n            );\n\n    font-size: 12px;\n}\n\n.app-comment-info h4 {\n\n    margin: 0 0 10px;\n\n    color: white;\n}\n\n.app-comment-info p {\n\n    margin: 0;\n\n    color:\n            rgba(\n                    255,\n                    255,\n                    255,\n                    0.8\n            );\n\n    white-space: pre-wrap;\n\n    line-height: 1.6;\n}\n\n.delete-btn {\n\n    height: 40px;\n\n    padding: 0 18px;\n\n    border: none;\n\n    border-radius: 10px;\n\n    background: #ff4d67;\n\n    color: white;\n\n    font-weight: 600;\n\n    cursor: pointer;\n}\n\n@media (max-width: 768px) {\n\n    .app-comment-card {\n\n        flex-direction: column;\n\n        align-items: flex-start;\n    }\n\n    .delete-btn {\n\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
